import { useEffect, useCallback, useContext, useState } from 'react';
import useCookie, { FF_OVERRIDE_KEY } from '../../utils/hooks/useCookie';
import { KNOWN_FEATURES, FeatureContext } from '../../context/FeatureProvider';
import { Box, Button, Grid2 as Grid, Switch, Typography } from '@mui/material';

export default function FeatureFlagPanel() {
  const { features } = useContext(FeatureContext);
  const { cookieValue, setCookie } = useCookie(FF_OVERRIDE_KEY);
  const [overrides, setOverrides] = useState(
    cookieValue ? JSON.parse(cookieValue) : {}
  );

  useEffect(() => {
    if (cookieValue) {
      setOverrides(JSON.parse(cookieValue));
    }
  }, [cookieValue]);

  const isEnabled = useCallback(
    (featureName: string) => {
      if (featureName in overrides) {
        return overrides[featureName];
      }
      return features?.some(({ feature_name }) => feature_name === featureName);
    },
    [features, overrides]
  );

  const onSaveOverrides = useCallback(() => {
    setCookie(JSON.stringify(overrides));
  }, [overrides, setCookie]);

  const onResetOverrides = useCallback(() => {
    setCookie('{}');
  }, [setCookie]);

  return (
    <Box sx={{ width: 600, p: 2 }}>
      {Object.values(KNOWN_FEATURES).map((feature) => (
        <Box
          key={feature}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant='subtitle2'>{feature}</Typography>
          <Switch
            checked={isEnabled(feature)}
            onChange={(e) => {
              setOverrides({ ...overrides, [feature]: e.target.checked });
            }}
          />
        </Box>
      ))}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid size={6}>
          <Button variant='outlined' fullWidth onClick={onResetOverrides}>
            Reset
          </Button>
        </Grid>
        <Grid size={6}>
          <Button
            variant='contained'
            color='secondary'
            fullWidth
            onClick={onSaveOverrides}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
